import { NgModule } from '@angular/core';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FooterComponent } from './components/footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Estrutura
import { SimplebarAngularModule } from 'simplebar-angular';
import { HeaderComponent } from './components/header/header.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { RequiredFieldLegendComponent } from './components/required-field-legend/required-field-legend.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { TabToTopComponent } from './components/tab-to-top/tab-to-top.component';

// Gráficos do dashboard
import { UiStatsComponent } from './ui-elements/ui-stats/ui-stats.component';
import { UiRecentProcessesComponent } from './ui-elements/ui-recent-processes/ui-recent-processes.component';
import { UsersByGroupComponent } from './ui-elements/users-by-group/users-by-group.component';
import { UiProcessesByStatusComponent } from './ui-elements/ui-processes-by-status/ui-processes-by-status.component';
import { UiProcessesProgressComponent } from './ui-elements/ui-processes-progress/ui-processes-progress.component';
import { UiProcessesTimelineComponent } from './ui-elements/ui-processes-timeline/ui-processes-timeline.component';
import { UiGroupsCompletionRateComponent } from './ui-elements/ui-groups-completion-rate/ui-groups-completion-rate.component';
import { UiActivityHeatmapComponent } from './ui-elements/ui-activity-heatmap/ui-activity-heatmap.component';
import { UiLatestProcessesByStatusComponent } from './ui-elements/ui-latest-processes-by-status/ui-latest-processes-by-status.component';

// Diretivas
import { HoverEffectSidebarDirective } from './directives/hover-effect-sidebar.directive';

// Pipes
import { TruncatePipe } from './pipes/truncate.pipe';
import { InitialsPipe } from './pipes/initials.pipe';

const UIELEMENTS = [UiStatsComponent, UiRecentProcessesComponent, UsersByGroupComponent, UiProcessesByStatusComponent, UiProcessesProgressComponent, UiProcessesTimelineComponent, UiGroupsCompletionRateComponent, UiActivityHeatmapComponent, UiLatestProcessesByStatusComponent];

const STANDALONE = [SearchBarComponent, PageHeaderComponent, RequiredFieldLegendComponent];

const COMPONENTS = [
  HeaderComponent,
  SidebarComponent,
  TabToTopComponent,
  FooterComponent,
  HoverEffectSidebarDirective,
];

@NgModule({
  declarations: [...COMPONENTS],

  imports: [
    CommonModule,
    RouterModule,
    SimplebarAngularModule,
    FormsModule,
    ReactiveFormsModule,
    TruncatePipe,
    InitialsPipe,
    ...STANDALONE,
    ...UIELEMENTS,
  ],
  exports: [...STANDALONE, ...COMPONENTS, ...UIELEMENTS, TruncatePipe, InitialsPipe],
})
export class SharedModule {}
